import React, { useState, useEffect } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { logout } from "features/authentication";
import { setStorageItem, urlParamsAsObject } from "@kateinnovations/javascript-helpers";
import Spinner from "@kateinnovations/ui-library/Loaders/Spinner";
import defaultConfig from "config/constants/defaultConfig";
import styles from "../resources/styles/login.module.scss";

const Logout = () => {
    const location = useLocation();
    const [loadRequest, setLoadRequest] = useState(true);
    const [state, setState] = useState(() => location.state);
    const [loginUrl] = useState(() => defaultConfig.path.react.auth.login);
    const [redirectUrl] = useState(() => urlParamsAsObject().redirect);

    useEffect(() => {
        if (redirectUrl) {
            const url = new URL(`${redirectUrl.startsWith("http") ? "" : "https://"}${redirectUrl}`);
            if (`//${url.host}` === defaultConfig.path.core.base)
                setState({ referer: { pathname: url.href.replace("https:", "") } });
        }
    }, [redirectUrl]);

    useEffect(() => {
        if (loadRequest) {
            const authLogout = async () => {
                setStorageItem("kateReloaded", false);
                const response = await logout();

                if (response.ok) setLoadRequest(false);
            };

            authLogout();
        }

        return () => {
            setLoadRequest(true);
        };
    }, [loadRequest, location]);

    if (!loadRequest) return <Redirect to={{ pathname: loginUrl, state }} />;

    return (
        <div className={styles.container}>
            <div className={styles.unit} variant="info">
                <Spinner state="visible" />
            </div>
        </div>
    );
};

export default Logout;
